export const MATH_FAQ_SECTIONS = [
  {
    title: 'GETTING STARTED',
    items: [
      {
        question: 'What are online math classes for kids?',
        answer: (
          <>
            Online math classes for kids are live, 1:1 learning sessions
            designed to help children from Grade 1 to Grade 12 understand Math
            at their own pace. Each class is taught by an expert teacher matched
            to your child&apos;s curriculum, using interactive tools and
            real-time practice.
          </>
        ),
        answerText:
          "Online math classes for kids are live, 1:1 learning sessions designed to help children from Grade 1 to Grade 12 understand Math at their own pace. Each class is taught by an expert teacher matched to your child's curriculum, using interactive tools and real-time practice.",
      },
      {
        question: 'Is there a free trial available?',
        answer: (
          <>
            Yes. Your child&apos;s first class is completely free with no
            commitment required. If you are not satisfied after your first paid
            class, there is a 100% money-back guarantee with no forms and no
            questions asked.
          </>
        ),
        answerText:
          "Yes. Your child's first class is completely free with no commitment required. If you are not satisfied after your first paid class, there is a 100% money-back guarantee with no forms and no questions asked.",
      },
      {
        question: 'How much do online math classes cost?',
        answer: (
          <>
            Pricing is flexible based on your child&apos;s grade and number of
            classes per week. It is designed to be more affordable than
            traditional 1:1 in-person tutoring. You can start with a free class
            before choosing a plan.
          </>
        ),
        answerText:
          "Pricing is flexible based on your child's grade and number of classes per week. It is designed to be more affordable than traditional 1:1 in-person tutoring. You can start with a free class before choosing a plan.",
      },
    ],
  },
  {
    title: 'ABOUT THE CLASSES',
    items: [
      {
        question: 'How do the classes work?',
        answer: (
          <>
            Each 45-minute session follows a structured format: revision,
            concept teaching using visual tools, guided practice on a shared
            whiteboard, mental Math exercises, independent problem solving, and
            homework at the right level. Every session is recorded for later
            review.
          </>
        ),
        answerText:
          'Each 45-minute session follows a structured format: revision, concept teaching using visual tools, guided practice on a shared whiteboard, mental Math exercises, independent problem solving, and homework at the right level. Every session is recorded for later review.',
      },
      {
        question: 'How many classes does my child need per week?',
        answer: (
          <>
            Most students take two classes per week for steady progress. Some
            choose one for light support or three during exam preparation. The
            schedule is personalized based on your child&apos;s needs.
          </>
        ),
        answerText:
          "Most students take two classes per week for steady progress. Some choose one for light support or three during exam preparation. The schedule is personalized based on your child's needs.",
      },
      {
        question: 'What time zones are supported?',
        answer: (
          <>
            Classes are available 7 days a week across major global time zones
            including US, UK, Australia, UAE, and Canada. Your child is matched
            with a teacher based on your preferred schedule.
          </>
        ),
        answerText:
          'Classes are available 7 days a week across major global time zones including US, UK, Australia, UAE, and Canada. Your child is matched with a teacher based on your preferred schedule.',
      },
      {
        question: 'What happens if my child misses a class?',
        answer: (
          <>
            All classes are recorded and available for lifetime access, so your
            child can revisit lessons anytime.
          </>
        ),
        answerText:
          'All classes are recorded and available for lifetime access, so your child can revisit lessons anytime.',
      },
    ],
  },
  {
    title: 'ABOUT THE TEACHERS',
    items: [
      {
        question: 'How are teachers selected?',
        answer: (
          <>
            Teachers are carefully selected from a large pool of qualified Math
            experts based on subject knowledge, teaching ability, and
            communication clarity. Most hold advanced degrees in Mathematics and
            have years of experience.
          </>
        ),
        answerText:
          'Teachers are carefully selected from a large pool of qualified Math experts based on subject knowledge, teaching ability, and communication clarity. Most hold advanced degrees in Mathematics and have years of experience.',
      },
      {
        question: 'Will my child understand the teacher clearly?',
        answer: (
          <>
            Yes. Teachers are matched based on your child&apos;s curriculum,
            learning pace, and communication comfort so lessons are easy to
            follow from day one.
          </>
        ),
        answerText:
          "Yes. Teachers are matched based on your child's curriculum, learning pace, and communication comfort so lessons are easy to follow from day one.",
      },
      {
        question: "What if my child doesn't connect with their teacher?",
        answer: (
          <>
            If the match isn&apos;t right, you can request a change anytime and
            a new teacher will be assigned immediately.
          </>
        ),
        answerText:
          "If the match isn't right, you can request a change anytime and a new teacher will be assigned immediately.",
      },
    ],
  },
  {
    title: 'CURRICULUM AND LEARNING',
    items: [
      {
        question: 'What curriculum is covered?',
        answer: (
          <>
            The programme covers major global curricula including CBSE, ICSE,
            IB, GCSE, IGCSE, Common Core, and more. Each learning plan is
            tailored to your child&apos;s exact school syllabus.
          </>
        ),
        answerText:
          "The programme covers major global curricula including CBSE, ICSE, IB, GCSE, IGCSE, Common Core, and more. Each learning plan is tailored to your child's exact school syllabus.",
      },
      {
        question: 'Are these 1:1 classes?',
        answer: (
          <>
            Yes. All sessions are 100% 1:1, meaning one teacher works with one
            child for the full class with complete attention and
            personalization.
          </>
        ),
        answerText:
          'Yes. All sessions are 100% 1:1, meaning one teacher works with one child for the full class with complete attention and personalization.',
      },
      {
        question: 'What grades are covered?',
        answer: (
          <>
            Classes are available from Grade 1 to Grade 12, with structured
            learning paths designed for each stage of school Math.
          </>
        ),
        answerText:
          'Classes are available from Grade 1 to Grade 12, with structured learning paths designed for each stage of school Math.',
      },
      {
        question: 'Can this help with exams and homework?',
        answer: (
          <>
            Yes. It supports homework, concept clarity, and exam preparation,
            including school tests and major board exams.
          </>
        ),
        answerText:
          'Yes. It supports homework, concept clarity, and exam preparation, including school tests and major board exams.',
      },
    ],
  },
  {
    title: 'SUPPORT AND PROGRESS',
    items: [
      {
        question: 'What support is included?',
        answer: (
          <>
            Students receive structured practice support, doubt resolution
            sessions, and additional help outside class when needed.
          </>
        ),
        answerText:
          'Students receive structured practice support, doubt resolution sessions, and additional help outside class when needed.',
      },
      {
        question: 'Can parents track progress?',
        answer: (
          <>
            Yes. Parents can view class recordings, progress reports, and
            learning milestones through a dedicated dashboard.
          </>
        ),
        answerText:
          'Yes. Parents can view class recordings, progress reports, and learning milestones through a dedicated dashboard.',
      },
    ],
  },
  {
    title: 'METHODOLOGY',
    items: [
      {
        question: 'How are these classes different from school learning?',
        answer: (
          <>
            Unlike traditional classrooms, these are fully interactive 1:1
            sessions where lessons adapt in real time to the child&apos;s
            understanding level.
          </>
        ),
        answerText:
          "Unlike traditional classrooms, these are fully interactive 1:1 sessions where lessons adapt in real time to the child's understanding level.",
      },
    ],
  },
]
